
import { defineComponent, PropType } from "vue";
import BaseIcon from "@/components/BaseIcon.vue";

export type TSocialItem = {
  title: string;
  link: string;
  icon: string;
};

export default defineComponent({
  name: "SocialItem",
  components: { BaseIcon },
  props: {
    item: {
      type: Object as PropType<TSocialItem>,
      required: true,
    },
  },
});
